export default __webpack_public_path__ + "static/media/actuality.b9fea77e.svg";